<p-toast></p-toast>

<div class="body-container">
    <div *ngIf="showTable0" class="table0-container mt-5" #tableContainer0>
        <p-card styleClass="p-card-shadow">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                    <!-- left-side-data -->
                </ng-template>
                <ng-template pTemplate="right">
                    <!-- <button *ngIf="dataTable1.length > 0" (click)="menu.toggle($event)" pButton pRipple
                        label="{{'EXPORT'| translate}}" icon="pi pi-upload" class="p-button-help"></button> -->
                    <button (click)="refreshTable1()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                    <!-- <p-menu #menu [popup]="true" [model]="exportMenuItemsT1"></p-menu> -->
                </ng-template>

            </p-toolbar>
            <div class="card dashboardTable">
                <p-table #table0 [value]="dataTable0" [scrollable]="false" sortField=""
                    sortMode="" [sortOrder]="" [paginator]="false" [globalFilterFields]="[
                'Application_Type',
                'Total_Application',
                'Total_Target_Days', 
                'Average_Time_Taken',
                ]" responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true" [loading]="loading0">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{ 'HARYANA_STATE_AVERAGE_TIME_LINE_REPORT'| translate }}
                            </h5>
                            <!-- <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="table0.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span> -->
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="Application_Type">{{'APPLICATION_TYPE'| translate}}
                                <p-columnFilter type="text" field="Application_Type" display="menu"></p-columnFilter>
                                <p-sortIcon field="Application_Type"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Total_Application">{{'TOTAL_APPLICATIONS'|
                                translate}}
                                <p-columnFilter type="text" field="Average_of_Total_Application" display="menu"></p-columnFilter>
                                <p-sortIcon field="Total_Application"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Total_Target_Days">{{'TOTAL_TARGET_DAYS'| translate}}
                                <p-columnFilter type="text" field="Total_Target_Days" display="menu"></p-columnFilter>
                                <p-sortIcon field="Total_Target_Days"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-val let-rowIndex="rowIndex">
                        <tr [ngStyle]="{'color': 'black'}">
                            <td>
                                <a (click)="onClickZeroTableRow(val)"
                                    style="cursor: pointer;">{{val.Application_Type}}</a>
                            </td>
                            <td>
                                {{val.Total_Application}}
                            </td>
                            <td>
                                {{val.Total_Target_Days}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-card>
    </div>

    <div *ngIf="showTable1" class="table1-container mt-5" #tableContainer1>
        <p-card styleClass="p-card-shadow">
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                    <!-- left-side-data -->
                </ng-template>
                <ng-template pTemplate="right">
                    <button *ngIf="dataTable1.length > 0" (click)="menu.toggle($event)" pButton pRipple
                        label="{{'EXPORT'| translate}}" icon="pi pi-upload" class="p-button-help"></button>
                    <!-- <button (click)="refreshTable1()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button> -->
                    <p-menu #menu [popup]="true" [model]="exportMenuItemsT1"></p-menu>
                </ng-template>

            </p-toolbar>
            <div class="card dashboardTable">
                <!-- <p-table #table1 [value]="dataTable1" [scrollable]="true" scrollHeight="100vh" sortField="Average_Time_Taken" sortMode="single" [sortOrder]="-1"  [paginator]="false" -->
                <p-table #table1 [value]="dataTable1" rowGroupMode="rowspan" groupRowsBy="District" sortField="District"
                    sortMode="single" [sortOrder]="1" [paginator]="false" [globalFilterFields]="[
                'District',
                'Application_Type',
                'Total_Application',
                'Target_Days', 
                'Average_Time_Taken'
                ]" responsiveLayout="scroll" [scrollable]="false" scrollHeight="100vh" [rowHover]="true"
                    [showCurrentPageReport]="true" [loading]="loading1">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'DISTRICT_WISE_AVERAGE_TIME_LINE_REPORT'| translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="table1.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="District">{{'DISTRICT'| translate}}
                                <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                                <p-sortIcon field="District"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Application_Type">{{'APPLICATION_TYPE'| translate}}
                                <p-columnFilter type="text" field="Application_Type" display="menu"></p-columnFilter>
                                <p-sortIcon field="Application_Type"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Total_Application">{{'TOTAL_APPLICATION'| translate}}
                                <p-columnFilter type="text" field="Total_Application" display="menu"></p-columnFilter>
                                <p-sortIcon field="Total_Application"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Target_Days">{{'TARGET_DAYS'| translate}}
                                <p-columnFilter type="text" field="Target_Days" display="menu"></p-columnFilter>
                                <p-sortIcon field="Target_Days"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Average_Time_Taken">{{'AVERAGE_TIME_TAKEN'| translate}}
                                <p-columnFilter type="text" field="Average_Time_Taken" display="menu"></p-columnFilter>
                                <p-sortIcon field="Average_Time_Taken"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <!-- <ng-template pTemplate="body" let-val let-rowIndex="rowIndex"> -->
                    <ng-template pTemplate="body" let-val let-rowIndex="rowIndex" let-rowgroup="rowgroup"
                        let-rowspan="rowspan">
                        <tr [ngStyle]="{'color': 'black'}">
                            <td *ngIf="rowgroup" [attr.rowspan]="rowspan">
                                <span class="font-bold ml-2">{{val.District}}</span>
                            </td>
                            <!-- <td>
                            {{val.District}}
                        </td> -->
                            <td>
                                {{val.Application_Type}}
                            </td>
                            <td>
                                <a (click)="onClickfirstTableRow(val)"
                                    style="cursor: pointer;">{{val.Total_Application}}</a>
                            </td>
                            <td>
                                {{val.Target_Days}}
                            </td>
                            <td>
                                {{val.Average_Time_Taken}}
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
            </div>
        </p-card>
    </div>



    <div *ngIf="showTable2" class="table2-container mt-5" #tableContainer2>
        <p-card styleClass="p-card-shadow">
            <div class="info mb-2">
                <p>{{ "NOTE: Please Scroll Up to move on previous table. Don't go back." | translate}}</p>
            </div>
            <!-- <div class="p-fluid p-formgrid justify-content-center mx-5" style="display: flex; flex-wrap:wrap">
            <div class="field md:col-6">
                <label>{{'DISTRICT'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedT1Row?.District }}</label></label>
            </div>
    
            <div class="field md:col-6">
                <label>{{'APPLICATION_TYPE'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedT1Row?.Application_Type }}</label></label>
            </div>
        </div> -->
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">

                </ng-template>
                <ng-template pTemplate="right">
                    <button *ngIf="dataTable2.length > 0" (click)="menu.toggle($event)" pButton pRipple
                        label="{{'EXPORT'| translate}}" icon="pi pi-upload" class="p-button-help"></button>
                    <!-- <button (click)="refreshTable1()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                    class="p-button-info ml-3"></button> -->
                    <p-menu #menu [popup]="true" [model]="exportMenuItemsT2"></p-menu>
                </ng-template>
            </p-toolbar>
            <div class="card dashboardTable">
                <!-- <p-table #table1 [value]="dataTable1" rowGroupMode="rowspan" groupRowsBy="district" sortField="averageTimeTaken" sortMode="single" [sortOrder]="-1" [rows]="10" [paginator]="true" -->
                <p-table #table2 [value]="dataTable2" [scrollable]="true" scrollHeight="100vh"
                    sortField="extraTimeTaken" sortMode="single" [sortOrder]="-1" [paginator]="false"
                    [globalFilterFields]="[
                'AppId',
                'ProgrammeName',
                'LastAction',
                'LastLevelId',
                'TargetDays',
                'TimeTaken',
                'Extra_Time_Taken', 
                'Delay_at_Department',
                'Delay_at_farmer_end',
                'Delay_at_Vendor_end'
                ]" responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true" [loading]="loading2">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{ selectedT1Row?.Application_Type + ' of ' + selectedT1Row?.District }}
                            </h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="table2.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="AppId">{{'APP_ID'| translate}}
                                <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                                <p-sortIcon field="AppId"></p-sortIcon>
                            </th>
                            <th *ngIf="programmeNamePresent" pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'|
                                translate}}
                                <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                                <p-sortIcon field="ProgrammeName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="LastAction">{{'LAST_ACTION'| translate}}
                                <p-columnFilter type="text" field="LastAction" display="menu"></p-columnFilter>
                                <p-sortIcon field="LastAction"></p-sortIcon>
                            </th>
                            <th pSortableColumn="LastLevelId">{{'LAST_LEVEL_ID'| translate}}
                                <p-columnFilter type="text" field="LastLevelId" display="menu"></p-columnFilter>
                                <p-sortIcon field="LastLevelId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TargetDays">{{'TARGET_DAYS'| translate}}
                                <p-columnFilter type="text" field="TargetDays" display="menu"></p-columnFilter>
                                <p-sortIcon field="TargetDays"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TimeTaken">{{'TIME_TAKEN'| translate}}
                                <p-columnFilter type="text" field="TimeTaken" display="menu"></p-columnFilter>
                                <p-sortIcon field="TimeTaken"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Extra_Time_Taken">{{'EXTRA_TIME_TAKEN'| translate}}
                                <p-columnFilter type="text" field="Extra_Time_Taken" display="menu"></p-columnFilter>
                                <p-sortIcon field="Extra_Time_Taken"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Delay_at_Department">{{'DELAY_AT_DEPT_END'| translate}}
                                <p-columnFilter type="text" field="Delay_at_Department" display="menu"></p-columnFilter>
                                <p-sortIcon field="Delay_at_Department"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Delay_at_farmer_end">{{'DELAY_AT_FARMER_END'| translate}}
                                <p-columnFilter type="text" field="Delay_at_farmer_end" display="menu"></p-columnFilter>
                                <p-sortIcon field="Delay_at_farmer_end"></p-sortIcon>
                            </th>
                            <th *ngIf="delayAtVendorPresent" pSortableColumn="Delay_at_Vendor_end">
                                {{'DELAY_AT_VENDOR_END'| translate}}
                                <p-columnFilter type="text" field="Delay_at_Vendor_end" display="menu"></p-columnFilter>
                                <p-sortIcon field="Delay_at_Vendor_end"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-val let-rowIndex="rowIndex">
                        <tr [ngStyle]="{'color': 'black'}">
                            <td>
                                <a (click)="onClickSecondTableRow(val)" style="cursor: pointer;">{{val.AppId}}</a>
                            </td>
                            <td *ngIf="programmeNamePresent">
                                {{val.ProgrammeName}}
                            </td>
                            <td>
                                {{val.LastAction}}
                            </td>
                            <td>
                                {{val.LastLevelId}}
                            </td>
                            <td>
                                {{val.TargetDays}}
                            </td>
                            <td>
                                {{val.TimeTaken}}
                            </td>
                            <td>
                                {{val.Extra_Time_Taken}}
                            </td>
                            <td>
                                {{val.Delay_at_Department}}
                            </td>
                            <td>
                                {{val.Delay_at_farmer_end}}
                            </td>
                            <td *ngIf="delayAtVendorPresent">
                                {{val.Delay_at_Vendor_end}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-card>
    </div>


    <div *ngIf="showTable3" class="table3-container mt-5" #tableContainer3>
        <p-card styleClass="p-card-shadow">
            <div class="info mb-2">
                <p>{{ "NOTE: Please Scroll Up to move on previous table. Don't go back." | translate}}</p>
            </div>
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">

                </ng-template>
                <ng-template pTemplate="right">
                    <button *ngIf="dataTable3.length > 0" (click)="menu.toggle($event)" pButton pRipple
                        label="{{'EXPORT'| translate}}" icon="pi pi-upload" class="p-button-help"></button>
                    <!-- <button (click)="refreshTable1()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                    class="p-button-info ml-3"></button> -->
                    <p-menu #menu [popup]="true" [model]="exportMenuItemsT3"></p-menu>
                </ng-template>
            </p-toolbar>
            <div class="card dashboardTable">
                <!-- <p-table #table1 [value]="dataTable1" rowGroupMode="rowspan" groupRowsBy="district" sortField="averageTimeTaken" sortMode="single" [sortOrder]="-1" [rows]="10" [paginator]="true" -->
                <p-table #table3 [value]="dataTable3" sortField="extraTimeTaken" sortMode="single" [sortOrder]="-1"
                    [paginator]="false" [globalFilterFields]="[
                'Action',
                'Level_Id',
                'UserId',
                'TargetDays',
                'TimeTaken', 
                'AssignedDate',
                'Action_Date',
                'Status',
                'Remarks',
                ]" responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true" [loading]="loading3">
                    <ng-template pTemplate="caption">
                        <div *ngIf="dataTable3Header != null"
                            class="p-fluid p-formgrid justify-content-center p-3 table3Header"
                            style="display: flex; flex-wrap:wrap; color: 'black'">
                            <div class="field md:col-12 table3HeaderContent">
                                <label>{{'APP_ID'| translate}}: &nbsp;<label [style]="{color: 'rgb(168, 32, 32)'}">{{
                                        dataTable3Header?.AppId }}</label></label>
                            </div>
                            <div class="field md:col-3 table3HeaderContent">
                                <label>{{'FARMER_NAME'| translate}}: &nbsp; <label
                                        [style]="{color: 'rgb(168, 32, 32)'}">{{ dataTable3Header?.Farmer_Name
                                        }}</label></label>
                            </div>
                            <div class="field md:col-5 table3HeaderContent">
                                <label>{{'VENDOR_NAME'| translate}}: &nbsp; <label
                                        [style]="{color: 'rgb(168, 32, 32)'}">{{ dataTable3Header?.Vendor_Name
                                        }}</label></label>
                            </div>
                            <div class="field md:col-3 table3HeaderContent">
                                <label>{{'MOBILE'| translate}}: &nbsp; <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                                        dataTable3Header?.Mobile }}</label></label>
                            </div>
                            <div class="field md:col-3 table3HeaderContent">
                                <label>{{'DISTRICT'| translate}}: &nbsp; <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                                        dataTable3Header?.District }}</label></label>
                            </div>
                            <div class="field md:col-3 table3HeaderContent">
                                <label>{{'BLOCK'| translate}}: &nbsp; <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                                        dataTable3Header?.Block }}</label></label>
                            </div>
                            <div class="field md:col-3 table3HeaderContent">
                                <label>{{'VILLAGE'| translate}}: &nbsp; <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                                        dataTable3Header?.Village }}</label></label>
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-end mt-2">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="table3.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="Action">{{'ACTION'| translate}}
                                <p-columnFilter type="text" field="Action" display="menu"></p-columnFilter>
                                <p-sortIcon field="Action"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Level_Id">{{'LEVEL_ID'| translate}}
                                <p-columnFilter type="text" field="Level_Id" display="menu"></p-columnFilter>
                                <p-sortIcon field="Level_Id"></p-sortIcon>
                            </th>
                            <th pSortableColumn="UserId">{{'USER_NAME'| translate}}
                                <p-columnFilter type="text" field="UserId" display="menu"></p-columnFilter>
                                <p-sortIcon field="UserId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TargetDays">{{'TARGET_DAYS'| translate}}
                                <p-columnFilter type="text" field="TargetDays" display="menu"></p-columnFilter>
                                <p-sortIcon field="TargetDays"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TimeTaken">{{'TIME_TAKEN'| translate}}
                                <p-columnFilter type="text" field="TimeTaken" display="menu"></p-columnFilter>
                                <p-sortIcon field="TimeTaken"></p-sortIcon>
                            </th>
                            <th pSortableColumn="AssignedDate">{{'ASSIGNED_DATE'| translate}}
                                <p-columnFilter type="text" field="AssignedDate" display="menu"></p-columnFilter>
                                <p-sortIcon field="AssignedDate"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Action_Date">{{'ACTION_DATE'| translate}}
                                <p-columnFilter type="text" field="Action_Date" display="menu"></p-columnFilter>
                                <p-sortIcon field="Action_Date"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Status">{{'STATUS'| translate}}
                                <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                                <p-sortIcon field="Status"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Remarks">{{'REMARKS'| translate}}
                                <p-columnFilter type="text" field="Remarks" display="menu"></p-columnFilter>
                                <p-sortIcon field="Remarks"></p-sortIcon>
                            </th>
                            <!-- <th pSortableColumn="MI">{{'MI'| translate}}
                            <p-columnFilter type="text" field="MI" display="menu"></p-columnFilter>
                            <p-sortIcon field="MI"></p-sortIcon>
                        </th>
                        <th pSortableColumn="On_Farm_Pond">{{'ON_FARM_POND'| translate}}
                            <p-columnFilter type="text" field="On_Farm_Pond" display="menu"></p-columnFilter>
                            <p-sortIcon field="On_Farm_Pond"></p-sortIcon>
                        </th> -->
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-val let-rowIndex="rowIndex">
                        <tr [ngStyle]="{'color': 'black'}">
                            <td>
                                {{val.Action}}
                            </td>
                            <td>
                                {{val.Level_Id}}
                            </td>
                            <td>
                                {{val.UserId}}
                            </td>
                            <td>
                                {{val.TargetDays}}
                            </td>
                            <td>
                                {{val.TimeTaken}}
                            </td>
                            <td>
                                {{val.AssignedDate}}
                            </td>
                            <td>
                                {{val.Action_Date}}
                            </td>
                            <td>
                                {{val.Status}}
                            </td>
                            <td>
                                {{val.Remarks}}
                            </td>
                            <!-- <td>
                            {{val.MI}}
                        </td>
                        <td>
                            {{val.On_Farm_Pond}}
                        </td> -->
                        </tr>
                    </ng-template>

                </p-table>
            </div>
        </p-card>
    </div>
</div>